// src/pages/seller/AnalyticsPage.jsx
import React, { useEffect, useState } from 'react';
// import { collection, query, where, onSnapshot } from 'firebase/firestore';
// import { db } from '../../utils/firebase';
import { useApp } from '../../context/AppContext';

const AnalyticsPage = () => {
  const { user } = useApp();
  const [analyticsData, setAnalyticsData] = useState({
    productViews: [],
    inquiries: [],
    conversionRate: 0,
    topCountries: []
  });

  // ✅ useEffect를 조건부 렌더링 전에 호출
  useEffect(() => {
    if (user?.status === 'pending') return;
    if (!user?.uid) return;

    // 실제 구현 시 Firestore에서 데이터 가져오기
    setAnalyticsData({
      productViews: [
        { product: 'Premium Faucet Set', views: 1240 },
        { product: 'Marble Countertop', views: 890 },
        { product: 'Kitchen Cabinet', views: 750 }
      ],
      inquiries: [
        { buyer: 'ABC Construction', product: 'Faucet Set', date: '2025-04-02' },
        { buyer: 'XYZ Builders', product: 'Countertop', date: '2025-04-01' }
      ],
      conversionRate: 12.5,
      topCountries: [
        { country: 'Canada', percentage: 65 },
        { country: 'USA', percentage: 20 },
        { country: 'UK', percentage: 10 },
        { country: 'Others', percentage: 5 }
      ]
    });
  }, [user?.uid, user?.status]);

  // ✅ 조건부 렌더링은 useEffect 이후에
  if (user?.status === 'pending') {
    return (
      <div className="text-center py-12">
        <div className="bg-yellow-50 p-6 rounded-lg inline-block max-w-2xl">
          <h3 className="text-xl font-medium text-yellow-800 mb-2">Account Pending Approval</h3>
          <p className="text-yellow-700">
            Analytics will be available after your account is approved.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-2xl font-medium text-gray-900 mb-6">Analytics</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 제품 조회수 */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium mb-4">Product Views</h2>
          <div className="space-y-3">
            {analyticsData.productViews.map((item, i) => (
              <div key={i} className="flex justify-between items-center">
                <span className="font-medium">{item.product}</span>
                <span className="text-gray-600">{item.views.toLocaleString()} views</span>
              </div>
            ))}
          </div>
        </div>
        
        {/* 문의 수 */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium mb-4">Recent Inquiries</h2>
          <div className="space-y-3">
            {analyticsData.inquiries.map((inquiry, i) => (
              <div key={i} className="p-3 border border-gray-200 rounded">
                <p className="font-medium">{inquiry.buyer}</p>
                <p className="text-sm text-gray-600">About: {inquiry.product}</p>
                <p className="text-xs text-gray-500 mt-1">{inquiry.date}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
        {/* 전환율 */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium mb-4">Conversion Rate</h2>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600">{analyticsData.conversionRate}%</div>
            <p className="text-gray-600 mt-2">View-to-purchase conversion rate</p>
          </div>
        </div>
        
        {/* 인기 지역 */}
        <div className="border border-gray-200 rounded-lg p-6">
          <h2 className="text-lg font-medium mb-4">Top Buyer Countries</h2>
          <div className="space-y-2">
            {analyticsData.topCountries.map((country, i) => (
              <div key={i}>
                <div className="flex justify-between mb-1">
                  <span>{country.country}</span>
                  <span>{country.percentage}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div 
                    className="bg-blue-600 h-2 rounded-full" 
                    style={{ width: `${country.percentage}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPage;